import { Injectable } from '@angular/core';
import { FormDefaultModel } from './models/FormDefaultModel';
import { HttpClient } from '@angular/common/http';
import { DefaultType } from './models/DefaultType';

@Injectable({
  providedIn: 'root'
})
export class FormDefaultsService {

  constructor(private http$: HttpClient) { }

  saveFormDefaults(formDefaults: FormDefaultModel) {
    return this.http$.post(`/api/formdefault/${formDefaults.clienteleId.toString()}/${formDefaults.type}`, { formValuesJson: formDefaults.formValueJson });
  }

  getFormDefaults(clienteleId: number, defaultType: DefaultType) {
    return this.http$.get<FormDefaultModel>(`/api/formdefault/${clienteleId.toString()}/${defaultType}`);

  }

  deleteFormDefaults(clienteleId: number, defaultType: DefaultType) {
    return this.http$.delete(`/api/formdefault/${clienteleId.toString()}/${defaultType}`);

  }
}
